<script>
  import { page } from '@inertiajs/svelte'
  import { onMount } from 'svelte'
  import { loadGoogleMaps } from './google_maps_loader.js'

  // Autocomplete text input. On selection, calls `onselect` with
  // { placeId, name, lat, lng, address, hours, phone, website }
  // (hours = Monday-first array of opening_hours.weekday_text).
  let { onselect, placeholder = 'Search for a place…' } = $props()

  const apiKey = $derived($page.props.google_maps_api_key)

  let inputEl = $state()
  let failed = $state(false)

  onMount(() => {
    if (!apiKey) {
      failed = true
      return
    }

    loadGoogleMaps(apiKey)
      .then(() => {
        const autocomplete = new google.maps.places.Autocomplete(inputEl, {
          fields: ['place_id', 'name', 'geometry', 'formatted_address', 'opening_hours', 'formatted_phone_number', 'website']
        })

        autocomplete.addListener('place_changed', () => {
          const place = autocomplete.getPlace()
          if (!place.geometry) return

          onselect?.({
            placeId: place.place_id || '',
            name: place.name || '',
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng(),
            address: place.formatted_address,
            hours: place.opening_hours?.weekday_text || [],
            phone: place.formatted_phone_number || '',
            website: place.website || ''
          })
        })
      })
      .catch(() => (failed = true))
  })
</script>

{#if failed}
  <input type="text" class="input w-full" placeholder="Place search unavailable — no Maps API key configured" disabled />
{:else}
  <input bind:this={inputEl} type="text" class="input w-full" {placeholder} />
{/if}
